<template>
  <div>
    <b-card no-body>
      <b-card-header>
        <b>Memberships</b>
        <b-button @click="showCreateUserMemberModal = true" variant="outline-primary" 
          class="headerBtn">
          <span class="button-text">Add Membership</span>
        </b-button>
      </b-card-header>

      <!-- List Member Organizations -->

      <div v-if="formatUserMemberships(usersMemberships).length > 0">
        <b-list-group v-for="um in formatUserMemberships(usersMemberships)" :key="um.id" flush>
          <b-list-group-item>
          <a href="" @click.prevent="toggleUpdateUserMemberModal(um.id)">
              {{_.get(um, 'morganization.title', 'Unknown') }}
            </a>
            <img  src='static/img/Primary.png' v-if="isPrimaryOrg(um.morganization.id)" height="21" width="21">
            <img :src="'static/img/' + (um.isOrgAdmin ? 'AdminYes.png' : 'AdminNo.png')" height="21" width="21">
            <img :src="'static/img/' + (um.isManager ? 'ManagerYes.png' : 'ManagerNo.png')" height="21" width="21">
            <img v-if="um.isDWUser" :src="'static/img/' + ('DWUserYes.png')" height="21" width="21">
          </b-list-group-item>
        </b-list-group>
      </div>

      <div v-if="formatUserMemberships(usersMemberships).length === 0">
        <b-list-group flush>
          <b-list-group-item>
            <p>
              {{ !hasOrganizations ? 'This user does not have memberships with any organizations.' : 'This user does not have memberships with any organizations.' }}
            </p>
          </b-list-group-item>
        </b-list-group>
      </div>
    </b-card>

    <!-- Add Organization Membership -->
    <CreateUserMemberModal
      :userId="userId"
      :pOrganization="user.primaryOrganization.id"
      :showModal.sync="showCreateUserMemberModal"
      :memOrg ="usersMembershipIds"
      >
    </CreateUserMemberModal>

    <!-- View/Edit Existing Membership -->
    <div v-if="memberRecordId !== 0">
      <UpdateUserMemberModal
        :userId="userId"
        :memberRecord="memberRecord"
        :showModal.sync="showUpdateUserMemberModal"
        :disableDelete = "isPrimaryOrg(memberRecord.morganization.id)">
      </UpdateUserMemberModal>
    </div>

  </div>
</template>

<script>
  import {
    mapGetters
  } from 'vuex'
  import CreateUserMemberModal from '@/components/Admin/CreateUserMemberModal.vue'
  import UpdateUserMemberModal from '@/components/Admin/UpdateUserMemberModal.vue'

  export default {
    name: 'user-member-list',
    props: {
      user: Object,
      userId: Number
    },
    components: {
      CreateUserMemberModal,
      UpdateUserMemberModal
    },
    data: function () {
      return {
        showCreateUserMemberModal: false,
        showUpdateUserMemberModal: false,
        memberRecordId: 0
      }
    },
    computed: {
      ...mapGetters({
        usersMemberships: 'viewUsersMembershipsSuccess'
      }),
      memberRecord: function () {
        var retVal = this.usersMemberships.find((r) => r.id === this.memberRecordId)
        if (retVal == null || retVal === undefined) {
          retVal = { morganization: { id: 0 } }
        }
        return retVal
      },
      hasOrganizations: function () {
        return this.user.memberOrganizations.length > 0
      },
      usersMembershipIds: function () {
        return this.usersMemberships.map(x => {
          if (x.morganization) {
            return x.morganization.id
          }
        })
      }
    },
    watch: {
    },
    methods: {
      isPrimaryOrg: function (tocheck) {
        if (this.user.primaryOrganization) {
          return this.user.primaryOrganization.id === tocheck
        }
        return false
      },
      toggleUpdateUserMemberModal: function (memberRecordId) {
        this.memberRecordId = memberRecordId
        this.showUpdateUserMemberModal = true
      },
      resetAll: function () {
        this.$store.commit('RESET_VIEW_MEMBERSHIP')
      },
      formatUserMemberships: function (memberships) {
        return _.sortBy(memberships, 'morganization.title')
          .filter(({ muser, morganization }) => !muser.isRemoved && !morganization.isRemoved)
      }
    },
    beforeDestroy () {
      this.resetAll()
    },
    created () {
      if (this.userId) {
        this.$store.dispatch('getUsersMembershipRecords', {
          muser: this.userId,
          populate: 'muser,morganization'
        })
      }
    }
  }
</script>
<style></style>



// WEBPACK FOOTER //
// src/components/Admin/UserMemberships.vue